import register from './modules/register'
import contestants from './modules/contestants'
import timing from './modules/timing'
import winner from './modules/winner'
import share from './modules/share'

import InstaplayAPI from '../../../services/api/instaplays'
import {getInstaplayFormState} from "@/store/States";
import {newDate} from "@/services/time";

const state = getInstaplayFormState()

const getters = {
    isValid: (state) => (name) => state.validation[name] === 'notValidated' || !state.validation[name] === false,
    isComplete: (state) => (name) => state.validation[name] === true,
    areAllValid: state => Object.values(state.validation).every(x => x),
    isLoading: state => state.status === 'loading',
    isItemLoading: state => state.itemStatus === 'loading',
    isSuccess: state => state.status === 'success',
    isItemSuccess: state => state.itemStatus === 'success',
    isError: state => state.status === 'error' ? state.errorMessage : false,
    isItemError: state => state.itemStatus === 'error',
}

const actions = {
    resetForm({commit, state}) {
        commit('setState', 1)
        commit('contestants/reset')
        for (let i = 0; i < Object.keys(state.validation).length; i++)
            commit('setValidation', {
                form: Object.keys(state.validation)[i],
                isValid: 'notValidated'
            })
    },

    setForm({state, commit}, instaplay) {
        state.limits.played = instaplay.numplayers !== 0
        state.limits.playedMessage = 'You may not edit this part because other users have participated in your Instaplay.'
        state.limits.type = instaplay.numContestants === 2 &&
            (instaplay.InstaplayType === 'total' ||
                instaplay.InstaplayType === 'spread' ||
                instaplay.InstaplayType === 'line')
        state.limits.typeMessage = `If you remove a contestant or add a new one, the type of the Instaplay may not remain ${instaplay.InstaplayType} anymore.`
        commit('register/setForm', {
            name: instaplay.name,
            image: instaplay.image,
            prompt: instaplay.prompt,
            category: instaplay.category,
            tournament: instaplay.tournament,
        })
        let contestants = []
        for (let i = 1; i <= instaplay.numContestants; i++) {
            let con = Object.assign({}, instaplay['contestant' + i])
            con.image = {url: con.image}
            con.probability *= 100
            contestants.push(con)
        }
        commit('contestants/setForm', contestants)
        let winner = {
            type: instaplay.InstaplayType
        }
        winner[winner.type] = instaplay[winner.type]
        commit('winner/setForm', winner)
        commit('timing/setForm', instaplay)
        const share = {
            privacy: instaplay.privacy,
        }
        if (share.privacy === 'invite') {
            share['inviteEmail'] = instaplay.inviteEmail
        }
        commit('share/setForm', share)
    },

    async createInstaplay({commit, state, rootState}, preview = false) {
        const type = state.winner.form.type
        const numOfContestants = state.contestants.cards.length
        const payload = {
            token: rootState.auth.user.token,
            name: state.register.form.name,
            image: state.register.form.image,
            prompt: state.register.form.prompt,
            category: state.register.form.category,
            InstaplayType: type,
            privacy: state.share.form.privacy,
            numContestants: numOfContestants,
            gameMaster: {userid: rootState.auth.user.userid, name: rootState.auth.user.fname},
        }
        if (state.register.form.partOfTournament)
            payload['tournament'] = state.register.form.tournament === 'new' ?
                state.register.form.newTournament : state.register.form.tournament
        // image: state.register.form.tournamentImage
        if (state.timing.form.deadline && state.timing.form.startOption === 'dateTime') {
            const date = newDate(state.timing.form.startDate, state.timing.form.startTime)
            payload['startMinute'] = date.getUTCMinutes()
            payload['startHour'] = date.getUTCHours()
            payload['startDay'] = date.getUTCDate()
            payload['startMonth'] = date.getUTCMonth() + 1
            payload['startYear'] = date.getUTCFullYear()
        }
        if (state.timing.form.winnerOption === 'dateTime') {
            const date = newDate(state.timing.form.winnerDate, state.timing.form.winnerTime)
            payload['winnerMinute'] = date.getUTCMinutes()
            payload['winnerHour'] = date.getUTCHours()
            payload['winnerDay'] = date.getUTCDate()
            payload['winnerMonth'] = date.getUTCMonth() + 1
            payload['winnerYear'] = date.getUTCFullYear()
        }
        payload[type] = Object.assign({}, state.winner[type])
        if (type === 'bracket') {
            let bracketModel = Object.assign({}, state.winner.bracket.bracketModel)
            Object.assign(payload['bracket'], state.winner.pool)
            let order = []
            for(let i = 1; i <= numOfContestants; i++)
                order.push(bracketModel[i])
            payload.bracket["order"] = order

            for (let i = 1; i <= numOfContestants; i++)
                delete bracketModel[i]

            payload.bracket["bracket"] = bracketModel
            delete payload.bracket.bracketModel

        }
        if (type === 'simple') {
            if (payload['simple'].hashtag === '')
                delete payload['simple'].hashtag
            if (payload['simple'].description === '')
                delete payload['simple'].description
            if (payload['simple'].image === '')
                delete payload['simple'].image
            if (payload['simple'].noLimit)
                payload['simple'].numWinners = -1
            delete payload['simple'].noLimit
        }
        for (let i = 1; i <= numOfContestants; i++) {
            let con = Object.assign({}, state.contestants.cards[i - 1])
            payload['contestant' + i] = con
            payload['contestant' + i].image = con.image.url
            payload['contestant' + i].probability = con.probability / 100.0

        }
        if (payload.privacy === 'invite') {
            payload["inviteEmail"] = state.share.form.group
            if (!payload.inviteEmail.modified) {
                payload.inviteEmail["modified"] = false
            }
        }
        if (payload.privacy === 'me') {
            payload["status"] = 'closed'
        }
        if (preview) return payload

        let response
        commit('loading')
        try {
            response = await InstaplayAPI.createInstaplay(payload)
        } catch (e) {
            commit('error')
            return
        }
        if (response.Success === 1) {
            commit('auth/updateScoins', response.user.scoins, {root: true})
            commit('success')
        } else commit('error', response.Message)
        return response.Success
    }
}

const mutations = {
    resetState(state) {
        Object.assign(state, getInstaplayFormState())
    },
    setState(state, n) {
        state.step = n
    },
    setValidation(state, payload) {
        state.validation[payload.form] = payload.isValid
    },
    loading(state) {
        state.status = 'loading'
    },
    success(state) {
        state.status = 'success'
    },
    error(state, message) {
        state.status = 'error'
        state.errorMessage = message
    },
    itemLoading(state) {
        state.itemStatus = 'loading'
    },
    itemSuccess(state) {
        state.itemStatus = 'success'
    },
    itemError(state) {
        state.itemStatus = 'error'
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        register: register,
        contestants: contestants,
        timing: timing,
        winner: winner,
        share: share
    }
}
